export interface IDataResponse
{
    status: number,
    ok: boolean,
    error?: string,
    file?: Promise<Blob>
}

export interface IResponse<T> extends IDataResponse
{
    json?: T | any;
}

//deze functie maakt een gewoon object van de promise 
export function parseResponse<T>(response: Response): Promise<IResponse<T>>
{
    return new Promise((resolve) =>
    {
        switch (response.status) {
            //500 = internal server error (geeft geen json terug)
            case 500: {
                resolve({
                    status: response.status,
                    ok: response.ok,
                    error: 'Status 500: Something went wrong',
                    json: { errors: ['Status 500: Something went wrong'] },
                });
                return;
            }
            //405 = method not supported (geeft geen json terug)
            case 405: {
                resolve({
                    status: response.status,
                    ok: response.ok,
                    error: 'Status 405: Something went wrong',
                    json: { errors: ['Status 405: Something went wrong'] },
                });
                return;
            }
            default: {
                response.json()     //200 = success, 201 = created, 400 = ... (geven wel een json terug)
                    .then((json: T | any) =>
                    {
                        // errors = an array of error strings provided by backend
                        // message = as single error message provided by backend
                        let errorString: string = '';
                        if (response.status === 404) { //'not found' message in object with prop 'message'
                            errorString = json.message;
                        }
                        else errorString = json.errors && Object.values(json.errors).toString() //validation errors in array 'errors'
                        resolve({
                            status: response.status,
                            ok: response.ok,
                            error: 'Status ' + response.status + ': ' + errorString,
                            json, //bevat de juiste inhoud (bij 200, 201) of "errors" (400)
                        })
                    })
                    .catch((error: Error) =>
                    { //als er (uitzonderlijk) toch geen json body is maar ook geen fout
                        // console.log(x)
                        resolve({
                            status: response.status,
                            ok: response.ok,
                        })
                    })
            }
        }
    });
}


export function parseFileResponse(response: Response): Promise<IDataResponse>
{

    return new Promise((resolve) =>
    {
        console.log(response)
        // resolve(response.blob())
        resolve({
            status: response.status,
            ok: response.ok,
            file: response.blob(),
        })
    })
}
